import {
  LOAD_PROFILE_SUCCESS,
  CHECK_AUTH_INFO_SUCCESS,
  GET_PROFESSION_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  CLOSE_PROFILE_SNACKBAR,
  WARN_NO_SSN,
  RESET_SCROLL_TO_SSN,
  LOCATION_CHANGE,
  GET_FIELD_OF_WORK_SUCCESS,
  SSN_DUPLICATE,
  UPDATE_USER_EMAIL_SUCCESS,
  UPDATE_USER_EMAIL_FAILED
} from '../constants'

const profileReducer = (
  state = {
    titleItems: [],
    showProfileSnackbar: false,
    showFailSnackbar: false,
    scrollToSSN: false,
    userData: [],
    fieldOfWork: [],
    showSsnWarningSnackbar: false,
    updateEmailFailedSnackbar: false,
    updateUserEmailSuccess: false
  },
  action
) => {
  switch (action.type) {
    case GET_FIELD_OF_WORK_SUCCESS:
      return {
        ...state,
        fieldOfWork: [...action.data]
      }

    case CHECK_AUTH_INFO_SUCCESS:
      return Object.assign({}, { ...state }, { ...action.result })

    case LOAD_PROFILE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          userData: action.result
        }
      )

    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          showProfileSnackbar: false,
          showSsnWarningSnackbar: false,
          showFailSnackbar: false,
          updateEmailFailedSnackbar: false
        }
      )

    case UPDATE_PROFILE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        { showProfileSnackbar: true },
        {
          userData: action.result
        }
      )

    case SSN_DUPLICATE:
      return Object.assign(
        {},
        { ...state },
        {
          showSsnWarningSnackbar: true
        }
      )

    case UPDATE_PROFILE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showProfileSnackbar: false,
          showFailSnackbar: true
        }
      )

    case CLOSE_PROFILE_SNACKBAR:
      return Object.assign({}, state, {
        showProfileSnackbar: false,
        showFailSnackbar: false,
        showSsnWarningSnackbar: false,
        updateEmailFailedSnackbar: false
      })

    case GET_PROFESSION_SUCCESS:
      //console.log('Inside Profile Reducer of profession:: ', action.profession)
      return Object.assign(
        {},
        { ...state },
        {
          titleItems: action.profession
        }
      )

    case WARN_NO_SSN:
      return Object.assign(
        {},
        { ...state },
        {
          scrollToSSN: true
        }
      )

    case RESET_SCROLL_TO_SSN:
      return Object.assign(
        {},
        { ...state },
        {
          scrollToSSN: false
        }
      )

    case UPDATE_USER_EMAIL_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          updateEmailFailedSnackbar: false,
          updateUserEmailSuccess: true
        }
      )
    case UPDATE_USER_EMAIL_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          updateEmailFailedSnackbar: true,
          updateUserEmailSuccess: false
        }
      )

    default:
      return state
  }
}

export default profileReducer
